import { Button, ControlGroup, MenuItem, Position } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import fetch from "node-fetch";
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import Page from '../../components/page';

const bedroomArr = [
  { id: 1, bhk: '1BHK' },
  { id: 2, bhk: '2BHK' },
  { id: 3, bhk: '3BHK' },
  { id: 4, bhk: '4BHK' },
  { id: 5, bhk: '5BHK' },
];

const budgetRent = [
  { id: 1, price: 'Upto 5K', max: 5000 },
  { id: 2, price: 'Upto 10k', max: 10000 },
  { id: 3, price: 'Upto 20K', max: 20000 },
  { id: 4, price: 'Upto 30K', max: 30000 },
  { id: 5, price: 'Upto 40K', max: 40000 },
  { id: 6, price: 'Upto 50K', max: 50000 },
  { id: 7, price: 'Upto 60K', max: 60000 },
  { id: 8, price: 'Upto 70K', max: 70000 },
  { id: 9, price: 'Upto 80K', max: 80000 },
  { id: 10, price: 'Upto 90K', max: 90000 },
  { id: 11, price: 'Upto 1L', max: 100000 },
  { id: 12, price: 'Upto 1.5L', max: 150000 },
  { id: 13, price: 'Upto 2L', max: 100000 },
  { id: 14, price: 'Upto 5L', max: 500000 },
  { id: 15, price: 'Upto 10L', max: 1000000 }
];

const budgetSale = [
  { id: 1, price: 'Upto 5L', max: 500000 },
  { id: 2, price: 'Upto 10L', max: 1000000 },
  { id: 3, price: 'Upto 20L', max: 2000000 },
  { id: 4, price: 'Upto 30L', max: 3000000 },
  { id: 5, price: 'Upto 40L', max: 4000000 },
  { id: 6, price: 'Upto 50L', max: 5000000 },
  { id: 7, price: 'Upto 60L', max: 6000000 },
  { id: 8, price: 'Upto 70L', max: 7000000 },
  { id: 9, price: 'Upto 80L', max: 8000000 },
  { id: 10, price: 'Upto 90L', max: 9000000 },
  { id: 11, price: 'Upto 1CR', max: 10000000 },
  { id: 12, price: 'Upto 1.5CR', max: 15000000 },
  { id: 13, price: 'Upto 2CR', max: 20000000 },
  { id: 14, price: 'Upto 3CR', max: 30000000 },
  { id: 15, price: 'Upto 5CR', max: 50000000 },
  { id: 16, price: 'Upto 10CR', max: 100000000 },
  { id: 17, price: 'Upto 15CR', max: 150000000 },
  { id: 18, price: 'Upto 20CR', max: 200000000 },
  { id: 19, price: 'Upto 30CR', max: 300000000 },
  { id: 20, price: 'Upto 40CR', max: 400000000 },
  { id: 21, price: 'Upto 50CR', max: 500000000 }
];

class Homepage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inventoryType: 'buy',
      bhkText: null,
      locationText: null,
      location: [],
      city: {
        uid: 'navi-mumbai',
        name: 'Navi Mumbai',
      },
      budget: null,
      errorMsg: '',
    };
  }

  handleSearchClick = () => {
    if (this.state.locationText == null) {
      this.setState({ errorMsg: 'Please select a location to continue search' });
    } else {
      let urlQueries = [];
      if (this.state.locationText !== null) {
        urlQueries.push(`areaUid=${this.state.locationText.uid}`);
      }
      if (this.state.budget !== null) {
        if (this.state.budget.max) {
          urlQueries.push(`maxPrice=${this.state.budget.max}`);
        }
        if (this.state.budget.min) {
          urlQueries.push(`minPrice=${this.state.budget.min}`);
        }
      }
      if (this.state.bhkText !== null) {
        urlQueries.push(`bedrooms=${this.state.bhkText.id}`);
      }

      this.props.history.push({
        pathname: this.state.inventoryType === 'buy' ? `/search/buy` : `search/rent`,
        search: `?${urlQueries.join('&')}`,
      });
    };
  }

  fetchCities() {
    let URL = '/v1/city-areas?cityUid=' + this.state.city.uid;
    fetch(URL)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result.message !== 'Ok') {
          return;
        }
        this.setState({
          location: result.data,
        });
      });
  }

  componentDidMount() {
    this.fetchCities();
  }

  itemRenderer(item, { handleClick }) {
    return (
      <MenuItem
        key={item.id}
        text={item.bhk}
        onClick={handleClick}
        shouldDismissPopover={true}
      />
    )
  }

  budgetItemRenderer(item, { handleClick }) {
    return (
      <MenuItem
        key={item.id}
        text={item.price}
        onClick={handleClick}
        shouldDismissPopover={true}
      />
    )
  }

  itemLocationRenderer = (item, { handleClick }) => {
    return (
      <MenuItem
        key={item.uid}
        text={`${item.name} (${this.state.city.name})`}
        onClick={handleClick}
        shouldDismissPopover={true}
      />
    )
  }

  handleclick = (item) => {
    //now this runs
    if (typeof item.name !== 'undefined') {
      this.setState({
        locationText: item
      });
    }
    else if (typeof item.bhk !== 'undefined') {
      this.setState({
        bhkText: item
      });
    }
    else if (typeof item.price !== 'undefined') {
      this.setState({
        budget: item
      })
    }
  }

  handleInventoryTypeChange = (value) => {
    this.setState({
      inventoryType: value
    });
  }

  render() {
    return (
      <Page id="homepage">
        <section className="hero has-background-white home-hero">
          <div className="hero-body">
            <div className="container">
              <h1 className="title tacenter">
                Buy / Rent Property Directly from Society
              </h1>
              <div className="search-box">
                <div className="tabs is-toggle has-text-centered">
                  <ul>
                    <li className={this.state.inventoryType == "buy" ? "is-active" : ""}>
                      <a onClick={() => { this.handleInventoryTypeChange("buy") }}>
                        <span>Buy</span>
                      </a>
                    </li>
                    <li className={this.state.inventoryType == "rent" ? "is-active" : ""}>
                      <a onClick={() => { this.handleInventoryTypeChange("rent") }}>
                        <span>Rent</span>
                      </a>
                    </li>
                  </ul>
                </div>
                {/* <RadioGroup
                  inline
                  onChange={this.handleInventoryTypeChange}
                  selectedValue={this.state.inventoryType}
                >
                  <Radio label="Buy" value="buy" large />
                  <Radio label="Rent" value="rent" large />
                </RadioGroup> */}
                <ControlGroup fill={true} vertical={false}>
                  <div className="selectBox">
                    <Select
                      items={this.state.location}
                      filterable={false}
                      itemRenderer={this.itemLocationRenderer}
                      onItemSelect={this.handleclick}
                      closeOnSelect
                    >
                      <Button
                        large
                        rightIcon="caret-down"
                        text={this.state.locationText ? this.state.locationText.name : 'Select Location'} />
                    </Select>
                    <Select
                      items={bedroomArr}
                      filterable={false}
                      itemRenderer={this.itemRenderer}
                      onItemSelect={this.handleclick}
                      closeOnSelect
                    >
                      <Button
                        large
                        rightIcon="caret-down"
                        text={this.state.bhkText ? this.state.bhkText.bhk : 'Any BHK'} />
                    </Select>
                    <Select
                      items={this.state.inventoryType === "buy" ? budgetSale : budgetRent}
                      filterable={false}
                      itemRenderer={this.budgetItemRenderer}
                      onItemSelect={this.handleclick}
                      closeOnSelect
                      popoverProps={{
                        popoverClassName: "tall-popover",
                        position: Position.BOTTOM,
                        modifiers: {
                          arrow: { enabled: true },
                          preventOverflow: { enabled: false, boundariesElement: "window" },
                        }
                      }}
                    >
                      <Button
                        large
                        rightIcon="caret-down"
                        text={this.state.budget ? this.state.budget.price : 'Select Budget'} />
                    </Select>
                    <Button
                      large
                      intent="success"
                      icon="search"
                      text="Search"
                      style={{ borderRadius: 0, justifyContent: "center" }}
                      onClick={this.handleSearchClick} />
                  </div>
                </ControlGroup>
              </div>
              <section className="content home-search-content">
                <p className="has-text-danger home-search-error">{this.state.errorMsg}</p>
                <h2>24x7 assistance</h2>
                <h2><FontAwesomeIcon icon={faWhatsapp} /> 7045655225</h2>
              </section>
            </div>
          </div>
        </section>
        <section className="hero is-bold has-space">
          <div className="hero-body">
            <div className="container">
              <h2 className="title title-light tacenter is-size-2">Why MyHomeKart?</h2>
              <div className="columns">
                <div className="column">
                  <div className="home-card">
                    <figure className="image is-128x128 has-text-success">
                      <i className="flaticon-medal flat-icon" />
                    </figure>
                    <h3>Right Advice</h3>
                    <p>We provide authentic advice to owner/buyer/tenant to avoid any dispute.</p>
                  </div>
                </div>
                <div className="column">
                  <div className="home-card">
                    <figure className="image is-128x128 has-text-success">
                      <i className="flaticon-list flat-icon" />
                    </figure>
                    <h3>Verified Properties</h3>
                    <p>We do background check of both property and owner/buyer/tenant for smooth deal.</p>
                  </div>
                </div>
                <div className="column">
                  <div className="home-card">
                    <figure className="image is-128x128 has-text-success">
                      <i className="flaticon-statistics flat-icon" />
                    </figure>
                    <h3>End-to-End Service</h3>
                    <p>We provide end to end service for all your property needs</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="hero is-bold has-space has-background-white">
          <div className="hero-body">
            <div className="container">
              <h2 className="title title-light tacenter is-size-2">Online Rent Agreement</h2>
              <div className="columns">
                <div className="column">
                  <div className="home-card">
                    <figure className="image is-128x128 has-text-info">
                      <i className="flaticon-monitor flat-icon" />
                    </figure>
                    <h3 className="hast-text-grey">Provide Information</h3>
                  </div>
                </div>
                <div className="column">
                  <div className="home-card">
                    <figure className="image is-128x128 has-text-info">
                      <i className="flaticon-bank flat-icon" />
                    </figure>
                    <h3 className="hast-text-grey">Make Payment</h3>
                  </div>
                </div>
                <div className="column">
                  <div className="home-card">
                    <figure className="image is-128x128 has-text-info">
                      <i className="flaticon-fingerprint flat-icon" />
                    </figure>
                    <h3 className="hast-text-grey">Biometric Collected</h3>
                  </div>
                </div>
                <div className="column">
                  <div className="home-card">
                    <figure className="image is-128x128 has-text-info">
                      <i className="flaticon-document flat-icon" />
                    </figure>
                    <h3 className="hast-text-grey">Download Agreement</h3>
                  </div>
                </div>
              </div>
              <section className="section">
                <div className="btn-block">
                  <Link
                    to={`/rentagreement`}
                    className="bp3-button bp3-intent-primary bp3-fill bp3-large"
                  >
                    Get Rent Agreement
                  </Link>
                </div>
              </section>
            </div>
          </div>
        </section>

        <section className="hero is-success">
          <div className="hero-body">
            <div className="container tacenter">
              <h2 className="title title-light is-size-2">Are you a Housing Society?</h2>
              <div className="columns" style={{ marginBottom: '2rem', marginTop: '2rem' }}>
                <div className="column">
                  <div className="society-card">
                    <figure className="image is-128x128">
                      <i className="flaticon-money flat-icon" />
                    </figure>
                    <h3>Get Brokerage Revenue Share</h3>
                  </div>
                </div>
                <div className="column">
                  <div className="society-card">
                    <figure className="image is-128x128">
                      <i className="flaticon-down flat-icon" />
                    </figure>
                    <h3>Reduce Maintainence Cost</h3>
                  </div>
                </div>
                <div className="column">
                  <div className="society-card">
                    <figure className="image is-128x128">
                      <svg className="icon-svg">
                        <use xlinkHref="#login" />
                      </svg>
                    </figure>
                    <h3>Collaborate Digitally</h3>
                  </div>
                </div>
              </div>
              <div className="btn-block has-text-dark">
                <Link
                  to={`/societyjoin`}
                  className="bp3-button bp3-fill bp3-large"
                >
                  Join Us
                </Link>
              </div>
            </div>
          </div>
        </section>

      </Page>
    );
  }
}

// export default () => (
//   <Page id="homepage">
//     <p>Here's our homepage. All are welcome.</p>
//     <img src={logo} alt="Homepage" style={{ width: '400px' }} />
//   </Page>
// );

export default withRouter(Homepage);



// WEBPACK FOOTER //
// ./src/app/routes/homepage/index.js